// extracted by mini-css-extract-plugin
export var circle = "_b2-1";
export var exitConfirmationModal = "_b2-5";
export var iframe = "_b2-0";
export var offline = "_b2-3";
export var online = "_b2-2";
export var workstationSelectError = "_b2-4";